import { render } from "./Locale-Switcher.vue?vue&type=template&id=55cef5bc&ts=true"
import script from "./Locale-Switcher.vue?vue&type=script&lang=ts"
export * from "./Locale-Switcher.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__